import { useEffect, useRef, useState } from 'react';

const processSteps = [
  {
    number: '01',
    icon: 'ri-truck-fill',
    title: 'Recolección',
    body: 'Recogemos plásticos posconsumo (HDPE, PET, PP) de hogares, colegios, empresas y calles de Santander. Llantas, envases, muebles plásticos: todo es materia prima para el material del futuro.',
    color: '#c62828',
  },
  {
    number: '02',
    icon: 'ri-filter-fill',
    title: 'Clasificación y Limpieza',
    body: 'El material se clasifica por tipo de polímero, se limpia y se tritura en partículas uniformes. Este proceso garantiza la pureza del insumo y la consistencia mecánica del producto final.',
    color: '#e65100',
  },
  {
    number: '03',
    icon: 'ri-fire-fill',
    title: 'Extrusión y Moldeo',
    body: 'Las partículas se funden a alta temperatura y se inyectan en moldes de precisión, creando tablas, vigas y perfiles de madera plástica de alto desempeño estructural.',
    color: '#f57f17',
  },
  {
    number: '04',
    icon: 'ri-hammer-fill',
    title: 'Construcción',
    body: 'Con el insumo producido, construimos parques infantiles, bancas, senderos, estructuras públicas y soluciones para la industria en los 87 municipios de Santander.',
    color: '#2e7d32',
  },
];

const benefits = [
  {
    icon: 'ri-time-fill',
    title: 'Inmune al Tiempo',
    value: '50+ años',
    text: 'Vida útil garantizada sin reemplazos',
    color: '#1b5e20',
    comparison: [
      { label: 'Madera natural', pct: 16, color: '#ef9a9a' },
      { label: 'Madera tratada', pct: 40, color: '#ffb74d' },
      { label: 'Madera plástica FRAIS', pct: 100, color: '#66bb6a' },
    ],
  },
  {
    icon: 'ri-tools-fill',
    title: 'Mantenimiento Cero',
    value: '$0',
    text: 'Sin pintura, barniz ni tratamientos anuales',
    color: '#c62828',
    comparison: [
      { label: 'Acero pintado', pct: 60, color: '#ef9a9a' },
      { label: 'Madera natural', pct: 85, color: '#ffb74d' },
      { label: 'Madera plástica FRAIS', pct: 5, color: '#66bb6a' },
    ],
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Resistencia Total',
    value: '100%',
    text: 'No se pudre, no se oxida, no le da termita',
    color: '#e65100',
    comparison: [
      { label: 'Resistencia al agua', pct: 100, color: '#42a5f5' },
      { label: 'Resistencia UV', pct: 90, color: '#ffa726' },
      { label: 'Resistencia química', pct: 95, color: '#ab47bc' },
    ],
  },
  {
    icon: 'ri-recycle-fill',
    title: 'Circular Infinito',
    value: '100%',
    text: 'Al final de su vida se recicla de nuevo',
    color: '#2e7d32',
    comparison: [
      { label: 'Reciclabilidad post-uso', pct: 100, color: '#66bb6a' },
      { label: 'Reducción CO₂ vs. madera', pct: 78, color: '#26c6da' },
      { label: 'Ahorro en extracción', pct: 92, color: '#ab47bc' },
    ],
  },
];

const applications = [
  {
    title: 'Parques Infantiles',
    desc: 'Columpios, toboganes, estructuras de trepa y juegos completamente fabricados con madera plástica. Bordes redondeados, sin astillas, sin óxido. Seguros, duraderos y coloridos para las comunidades de Santander.',
    photo: 'https://readdy.ai/api/search-image?query=colorful%20children%20playground%20park%20built%20entirely%20with%20recycled%20plastic%20lumber%20wood%2C%20bright%20play%20structures%2C%20slides%2C%20swings%20made%20from%20recycled%20plastic%20boards%2C%20green%20grass%2C%20Colombia%20community%20park%2C%20sunny%20day%2C%20vibrant%20colors%2C%20clean%20background&width=800&height=560&seq=plastic-park-001&orientation=landscape',
    color: '#f57f17',
    icon: 'ri-ball-pen-fill',
  },
  {
    title: 'Bancas y Mobiliario',
    desc: 'Bancas para parques, mesas comunitarias, jardineras y estructuras de descanso. Disponibles en múltiples perfiles y colores. Cómpralo una vez, olvídalo para siempre.',
    photo: 'https://readdy.ai/api/search-image?query=outdoor%20park%20benches%20and%20furniture%20made%20from%20recycled%20plastic%20lumber%20boards%2C%20dark%20green%20and%20brown%20recycled%20plastic%20wood%20benches%20in%20a%20public%20park%2C%20eco%20friendly%20urban%20furniture%2C%20clean%20modern%20design%2C%20Colombia%2C%20lush%20greenery%20background&width=800&height=560&seq=plastic-bench-002&orientation=landscape',
    color: '#2e7d32',
    icon: 'ri-sofa-fill',
  },
  {
    title: 'Senderos y Alamedas',
    desc: 'Tablones para senderos ecológicos, puentes peatonales, pasillos de parques y alamedas arbolizadas. Antideslizante, resistente al clima tropical de Santander y sin mantenimiento.',
    photo: 'https://readdy.ai/api/search-image?query=walking%20path%20boardwalk%20made%20from%20recycled%20plastic%20lumber%20planks%20through%20green%20park%2C%20eco%20path%20with%20recycled%20plastic%20wood%20boards%2C%20nature%20trail%20walkway%20Colombia%2C%20surrounded%20by%20trees%20and%20plants%2C%20warm%20afternoon%20light&width=800&height=560&seq=plastic-path-003&orientation=landscape',
    color: '#43a047',
    icon: 'ri-walk-fill',
  },
  {
    title: 'Casas y Estructuras',
    desc: 'Viviendas, kioscos, cobertizos y estructuras comunitarias construidas con madera plástica. Una alternativa real, sostenible y de larga duración a la madera convencional para construir hogares dignos.',
    photo: 'https://readdy.ai/api/search-image?query=small%20house%20and%20community%20structure%20built%20from%20recycled%20plastic%20lumber%20boards%2C%20ecological%20home%20construction%20using%20recycled%20plastic%20wood%20planks%2C%20kiosk%20cabin%20shelter%20made%20with%20plastic%20lumber%2C%20Colombia%20rural%20community%2C%20natural%20surroundings%2C%20clear%20day&width=800&height=560&seq=plastic-house-004&orientation=landscape',
    color: '#c62828',
    icon: 'ri-home-heart-fill',
  },
];

export default function PlasticWoodSection() {
  const [activeApp, setActiveApp] = useState(0);
  const [activeBenefit, setActiveBenefit] = useState(0);
  const [animBars, setAnimBars] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const stepsRef = useRef<HTMLDivElement>(null);
  const benefitsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setAnimBars(false);
    const t = setTimeout(() => setAnimBars(true), 80);
    return () => clearTimeout(t);
  }, [activeBenefit]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (entry.target === stepsRef.current) {
            const items = entry.target.querySelectorAll('.step-item');
            items.forEach((item, i) => {
              setTimeout(() => {
                (item as HTMLElement).style.opacity = '1';
                (item as HTMLElement).style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
          if (entry.target === benefitsRef.current) {
            setAnimBars(true);
          }
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1 }
    );
    if (stepsRef.current) observer.observe(stepsRef.current);
    if (benefitsRef.current) observer.observe(benefitsRef.current);
    return () => observer.disconnect();
  }, []);

  const benefit = benefits[activeBenefit];

  return (
    <section ref={sectionRef} className="bg-[#fafaf8] py-24 md:py-32 overflow-hidden">

      {/* ── HEADER ── */}
      <div className="px-6 md:px-14 mb-20">
        <div className="max-w-6xl mx-auto">
          <span
            className="inline-block text-[#43a047] text-[10px] tracking-[0.45em] uppercase font-semibold mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Ingeniería Circular · Insumo Industrial Superior
          </span>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <h2
              className="text-[#1b5e20] font-bold leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2.2rem, 4.5vw, 4rem)' }}
            >
              No lo llamamos plástico.<br />
              <span style={{ color: '#43a047' }}>Lo llamamos el material del futuro.</span>
            </h2>
            <p className="text-[#4a5568] text-base leading-relaxed max-w-md" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Transformamos el plástico que contamina Santander en madera plástica de alto desempeño. 
              No se pudre, no se oxida, no le da termita — y dura más de 50 años sin mantenimiento. 
              Construir con FRAIS es construir para siempre.
            </p>
          </div>
        </div>
      </div>

      {/* ── PROCESS STEPS ── */}
      <div className="px-6 md:px-14 mb-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-px bg-[#43a047]"></div>
            <span className="text-[#43a047] text-xs tracking-[0.4em] uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              El proceso de transformación
            </span>
          </div>
          <div ref={stepsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {processSteps.map((step, i) => (
              <div
                key={step.number}
                className="step-item relative bg-white rounded-2xl p-7 group hover:-translate-y-1 transition-transform duration-300"
                style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
              >
                <span
                  className="absolute top-5 right-6 text-6xl font-bold leading-none select-none"
                  style={{ color: step.color + '10', fontFamily: "'Playfair Display', serif" }}
                >
                  {step.number}
                </span>
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 flex-shrink-0"
                  style={{ backgroundColor: step.color + '18' }}
                >
                  <i className={`${step.icon} text-xl`} style={{ color: step.color }}></i>
                </div>
                <p className="text-[10px] font-bold tracking-[0.35em] uppercase mb-1" style={{ color: step.color, fontFamily: "'Montserrat', sans-serif" }}>
                  Paso {step.number}
                </p>
                <h3 className="text-[#1b5e20] font-bold text-lg mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {step.title}
                </h3>
                <p className="text-[#6b7280] text-sm leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {step.body}
                </p>
                {i < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-14 -right-3 w-6 h-px bg-[#e5e7eb] z-10"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── APPLICATIONS ── */}
      <div className="px-6 md:px-14 mb-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-px bg-[#43a047]"></div>
            <span className="text-[#43a047] text-xs tracking-[0.4em] uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              ¿Qué construimos?
            </span>
          </div>

          <div className="flex gap-3 mb-8 flex-wrap">
            {applications.map((app, i) => (
              <button
                key={app.title}
                onClick={() => setActiveApp(i)}
                className={`px-6 py-2.5 rounded-full text-xs font-bold tracking-wider uppercase transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeApp === i ? 'text-white scale-105' : 'text-gray-500 bg-white hover:text-gray-700'
                }`}
                style={{ fontFamily: "'Montserrat', sans-serif", backgroundColor: activeApp === i ? app.color : undefined }}
              >
                {app.title}
              </button>
            ))}
          </div>

          <div
            key={activeApp}
            className="grid grid-cols-1 md:grid-cols-2 rounded-2xl overflow-hidden"
            style={{ animation: 'fadeInApp 0.4s ease', backgroundColor: applications[activeApp].color + '10' }}
          >
            <div className="relative overflow-hidden" style={{ minHeight: '340px' }}>
              <img
                src={applications[activeApp].photo}
                alt={applications[activeApp].title}
                className="w-full h-full object-cover object-center"
                style={{ minHeight: '340px' }}
              />
              <div
                className="absolute inset-0 opacity-40"
                style={{ background: `linear-gradient(135deg, ${applications[activeApp].color}80 0%, transparent 60%)` }}
              ></div>
            </div>
            <div className="flex flex-col justify-center p-8 md:p-12">
              <div
                className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-6"
                style={{ backgroundColor: applications[activeApp].color + '20' }}
              >
                <i className="ri-hammer-fill text-2xl" style={{ color: applications[activeApp].color }}></i>
              </div>
              <h3
                className="text-[#1b5e20] font-bold text-2xl mb-4 leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {applications[activeApp].title}
              </h3>
              <p className="text-[#4a5568] text-sm leading-relaxed mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {applications[activeApp].desc}
              </p>
              <p className="text-[#9ca3af] text-xs" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Fabricado en Bucaramanga con plástico reciclado de Santander — sin talar un solo árbol.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ── BENEFITS — interactive cards with comparison bars ── */}
      <div className="px-6 md:px-14 mb-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-px bg-[#43a047]"></div>
            <span className="text-[#43a047] text-xs tracking-[0.4em] uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              La Anatomía del Material · Propiedades FRAIS
            </span>
          </div>

          {/* Benefit selector */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
            {benefits.map((b, i) => (
              <button
                key={b.title}
                onClick={() => setActiveBenefit(i)}
                className="flex flex-col items-start gap-2 p-4 rounded-xl text-left transition-all duration-300 cursor-pointer"
                style={{
                  backgroundColor: activeBenefit === i ? b.color + '12' : '#fff',
                  border: `1px solid ${activeBenefit === i ? b.color + '50' : '#e5e7eb'}`,
                }}
              >
                <div
                  className="w-9 h-9 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: activeBenefit === i ? b.color : b.color + '15' }}
                >
                  <i className={`${b.icon} text-sm`} style={{ color: activeBenefit === i ? '#fff' : b.color }}></i>
                </div>
                <p className="font-bold text-sm text-[#1b5e20]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {b.title}
                </p>
                <p className="text-[10px] text-gray-400" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {b.value}
                </p>
              </button>
            ))}
          </div>

          {/* Active benefit detail */}
          <div
            key={activeBenefit}
            ref={benefitsRef}
            className="grid grid-cols-1 md:grid-cols-2 gap-8 rounded-2xl overflow-hidden bg-white p-8 md:p-10"
            style={{ border: `1px solid ${benefit.color}20`, animation: 'fadeInApp 0.4s ease' }}
          >
            {/* Left: info */}
            <div className="flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-5">
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: benefit.color + '18' }}
                >
                  <i className={`${benefit.icon} text-2xl`} style={{ color: benefit.color }}></i>
                </div>
                <div>
                  <p className="text-[9px] tracking-[0.4em] uppercase font-bold mb-0.5" style={{ color: benefit.color, fontFamily: "'Montserrat', sans-serif" }}>
                    Propiedad FRAIS
                  </p>
                  <h3 className="text-[#1b5e20] font-bold text-xl" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {benefit.title}
                  </h3>
                </div>
              </div>
              <div className="flex items-baseline gap-2 mb-3">
                <span className="font-bold" style={{ color: benefit.color, fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}>
                  {benefit.value}
                </span>
              </div>
              <p className="text-[#4a5568] text-sm leading-relaxed mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {benefit.text}
              </p>
              <div
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold w-fit"
                style={{ backgroundColor: benefit.color + '12', color: benefit.color, fontFamily: "'Montserrat', sans-serif" }}
              >
                <i className="ri-award-fill"></i>
                Avalado por CDMB · Santander
              </div>
            </div>

            {/* Right: comparison bars */}
            <div className="flex flex-col justify-center gap-6">
              <p className="text-[#9ca3af] text-[10px] tracking-[0.4em] uppercase" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Comparativa de rendimiento
              </p>
              {benefit.comparison.map((bar, i) => (
                <div key={bar.label}>
                  <div className="flex items-end justify-between mb-2">
                    <span className="text-[#4a5568] text-xs font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {bar.label}
                    </span>
                    <span className="text-xs font-bold" style={{ color: bar.color, fontFamily: "'Montserrat', sans-serif" }}>
                      {bar.pct}%
                    </span>
                  </div>
                  <div className="h-2 rounded-full bg-[#f0f0f0] overflow-hidden">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: animBars ? `${bar.pct}%` : '0%',
                        backgroundColor: bar.color,
                        transition: `width 0.9s cubic-bezier(0.16,1,0.3,1) ${i * 0.15}s`,
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── CDMB PARTNERSHIP ── */}
      <div className="px-6 md:px-14">
        <div className="max-w-6xl mx-auto">
          <div
            className="relative overflow-hidden rounded-2xl"
            style={{ background: 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 50%, #388e3c 100%)' }}
          >
            <div className="absolute inset-0 opacity-5">
              <img
                src="https://storage.readdy-site.link/project_files/99b3bf7a-f106-44a8-ac25-700226859767/0b87572f-7f8f-467b-ba4f-35099c99dd1a_WhatsApp-Image-2026-04-19-at-12.03.53.jpeg?v=e7dccea8c4ac43142940d1919f7934e0"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-0">
              <div className="p-10 md:p-14 flex flex-col justify-center">
                <div className="flex items-center gap-5 mb-8 p-5 rounded-2xl" style={{ backgroundColor: 'rgba(255,255,255,0.12)', backdropFilter: 'blur(8px)' }}>
                  <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0 bg-white flex items-center justify-center p-1">
                    <img
                      src="https://static.readdy.ai/image/04072f05a7ab05cce1b5fc08d2859ba4/18cb634e8174a80226c2f4a8c6762f2e.png"
                      alt="Logo CDMB"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div>
                    <span className="text-[#a5d6a7] text-[9px] tracking-[0.45em] uppercase font-bold block mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Aliado estratégico oficial
                    </span>
                    <p className="text-white font-bold text-base leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>CDMB</p>
                    <p className="text-white/60 text-xs mt-0.5" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      Corporación Autónoma Regional para la Defensa de la Meseta de Bucaramanga
                    </p>
                  </div>
                </div>

                <h3
                  className="text-white font-bold leading-tight mb-4"
                  style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.5rem, 2.8vw, 2.2rem)' }}
                >
                  Trabajamos juntos por la recuperación de Santander
                </h3>

                <p className="text-white/70 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  La <strong className="text-white">CDMB</strong> avala y respalda nuestro proceso de ingeniería circular. Trabajamos coordinadamente para la recuperación de zonas críticas, protección de la meseta de Bucaramanga y restauración ecológica del departamento.
                </p>

                <div className="flex flex-col gap-4">
                  {[
                    { icon: 'ri-leaf-fill', text: 'Recuperación de zonas críticas en la meseta de Bucaramanga' },
                    { icon: 'ri-shield-fill', text: 'Proceso de transformación avalado institucionalmente por la CDMB' },
                    { icon: 'ri-map-2-fill', text: 'Intervención coordinada en los 87 municipios de Santander' },
                    { icon: 'ri-plant-fill', text: 'Restauración ecológica conjunta con siembra de especies nativas' },
                  ].map((item) => (
                    <div key={item.text} className="flex items-start gap-3">
                      <div className="w-6 h-6 rounded-full bg-[#43a047]/40 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-[#a5d6a7] text-xs`}></i>
                      </div>
                      <p className="text-white/80 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-10 md:p-14 flex flex-col justify-center lg:border-l border-white/10">
                <div className="bg-white/10 rounded-2xl p-8 mb-6">
                  <i className="ri-double-quotes-l text-[#a5d6a7] text-3xl mb-4 block"></i>
                  <blockquote className="text-white font-light text-lg leading-relaxed" style={{ fontFamily: "'Playfair Display', serif" }}>
                    La alianza entre Fundación Frais y la CDMB representa el modelo de colaboración que Santander necesita: ingeniería circular con propósito, espacios recuperados y comunidades activas.
                  </blockquote>
                  <p className="text-white/50 text-xs mt-5 uppercase tracking-widest" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    — Fundación Frais, 2025
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {[
                    { value: '87', label: 'Municipios intervenidos' },
                    { value: '2022', label: 'Inicio del proyecto' },
                    { value: 'CDMB', label: 'Corporación que nos avala' },
                    { value: '100%', label: 'Plástico reciclado posconsumo' },
                  ].map((stat) => (
                    <div key={stat.label} className="rounded-xl p-4 text-center" style={{ backgroundColor: 'rgba(255,255,255,0.08)' }}>
                      <p className="text-[#a5d6a7] text-xl font-bold mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</p>
                      <p className="text-white/50 text-[10px] uppercase tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInApp {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
